import CountUp from "react-countup";

export default function CountUP({ end, type = 'price', accounting = {} }) {

	if (type != 'price' && !accounting) return null;
    
	let prefix = "";
  	let suffix = "";
  	let currencySymbol = accounting.currency_format_symbol;

	switch (accounting.currency_pos) {
		case "left":
			prefix = currencySymbol;
			break;
		
		case "left_space":
			prefix = currencySymbol + " ";
			break;
			
		case "right":
			suffix = currencySymbol;
			break;
		
		case "right_space":
			suffix = " " + currencySymbol;
			break;
	}

  	return (
		<>
		{ 'price' == type ? (
			<CountUp
				end={end}
				decimals={accounting.currency_format_num_decimals}
				decimal={accounting.currency_format_decimal_sep}
				separator={accounting.currency_format_thousand_sep}
				prefix={prefix}
				suffix={suffix}
			/>
		) : (
			<CountUp end={end} />
		)}
		</>
  	);
}